<div class="action-matrix">
	@for(button of sortedData(); track button.order;){
		<div class="mb-2" [class]="button.color+' '+ button.fill+' '+ button.width +' '+button.disabled " (click)="onClick(button)">
			<div class="d-flex justify-content-between mb-3">
				<h4 class="m-0">
					@if(button.complete) {
						<i class="fa-fw fa-solid fa-circle-check"></i>
					}
					{{button.header}}
				</h4>
				@if(!button.disabled){
					<i class="fa-fw fa-regular fa-chevron-right pt-1"></i>
				}@else {
					<i class="fa-fw fa-regular fa-lock-keyhole pt-1"></i>
				}
				
			</div>
			@if(button.subText) {
				<p class="m-0 d-table-row">{{button.subText}}</p>
			}
		</div>
	}
</div>